<template>
  <div id="map-container">
    <v-map
      ref="mapRef"
      :zoom="zoom"
      :center="center" 
      style="height: 100%; width: 100%;"
    >
      <!-- 地图底图图层 -->
      <v-tilelayer
      :cross-origin="false"
        url="https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png"
        attribution="&copy; OpenStreetMap contributors"
      ></v-tilelayer>

      <!-- 点聚合组件，包裹所有 Marker -->
      <v-marker-cluster :options="{ chunkedLoading: true }">
        <!-- 使用 v-for 循环渲染大量坐标点 -->
        <v-marker
          v-for="(point, index) in points"
          :key="index"
          :lat-lng="[point.lat, point.lng]"
          :icon="customIcon"
        >
          <!-- 可选的点击弹出信息 -->
          <v-popup :content="`这是${point.title}`"></v-popup>
        </v-marker>
      </v-marker-cluster>
    </v-map>
  </div>
</template>

<script>
// 1. 引入 Leaflet 核心库和样式
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// 2. 引入 Vue2Leaflet 组件和 MarkerCluster 插件
import { LMap, LTileLayer, LMarker, LPopup } from 'vue2-leaflet';
import Vue2LeafletMarkercluster from 'vue2-leaflet-markercluster';

// 3. 引入 MarkerCluster 插件样式（必须）
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';

export default {
  name: 'MapDemo',
  components: {
    'v-map': LMap,
    'v-tilelayer': LTileLayer,
    'v-marker': LMarker,
    'v-popup': LPopup,
    'v-marker-cluster': Vue2LeafletMarkercluster,
  },
  props: {
    zoom: {
      type: Number,
      default: 13,
    },
    markers: {
      type: Array,
      default: () => [],
    },
    center: {
      type: Array,
      default: () => [39.906901, 116.397972], // 默认中心点为北京天安门
    },
  },
  watch: {
    markers: {
      handler(newMarkers) {
        this.points = newMarkers;
      },
      deep: true,
    },
  },
  data() {
    return {
      points: [], // 存储所有坐标点
         customIcon: L.icon({
        iconUrl: 'https://cdn.jsdelivr.net/npm/leaflet@1.7.1/dist/images/marker-icon.png',
        shadowUrl: 'https://cdn.jsdelivr.net/npm/leaflet@1.7.1/dist/images/marker-shadow.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41]
      })
    };
  },
  mounted() {
    // 模拟生成10000个随机坐标点（大致在武汉附近）
    // const baseLat = 30.5;
    // const baseLng = 114.3;
    // const generateRandomPoints = (count) => {
    //   const result = [];
    //   for (let i = 0; i < count; i++) {
    //     // 随机偏移约 0.1 度，生成聚集效果
    //     const lat = baseLat + (Math.random() - 0.5) * 0.2;
    //     const lng = baseLng + (Math.random() - 0.5) * 0.2;
    //     result.push({ lat, lng,title:'点位' + (i + 1) });
    //   }
    //   return result;
    // };
    // this.points = generateRandomPoints(1000);

    this.points = this.markers;
  },
  beforeDestroy() {
  // 先判断地图实例是否存在
  if (!this.$refs.map || !this.$refs.map.mapObject) return
  const map = this.$refs.map.mapObject
  // 先清除所有图层，再销毁地图，避免聚合图层报错
  map.eachLayer(layer => {
    map.removeLayer(layer)
  })
  // 销毁地图容器实例
  map.remove()
  // 清空ref引用，彻底释放
  this.$refs.map = null
}
};
</script>

<style scoped>
/* 地图容器必须设置固定高度，否则无法显示 */
#map-container {
  height: calc(100% - 10px); /* 根据实际需求调整高度 */
  width: 100%;
}
</style>